import {  FaCloudscale,FaGg, FaMobile } from "react-icons/fa";
import { SiDatabricks } from "react-icons/si";
import { MdConnectWithoutContact } from "react-icons/md";

export const FeatureList = [
  {
    id: 1,
    icon: <FaMobile color="#0a1930" size={22} />,
    heading: "Diseño adaptado",
    text: "Creamos aplicaciones móviles a la medida, adaptadas a tus necesidades y diseñadas para impulsar tu negocio en el mundo digital. Uso de inteligencia artificial (IA).",
  },
  {
    id: 2,
    icon: <SiDatabricks color="#0a1930" size={22} />,
    heading: "Personal Outsourcing",
    text: "Impulsamos tu negocio con talento especializado. Servicios de outsourcing a medida para maximizar eficiencia y productividad.",
  },
  {
    id: 3,
    icon: <MdConnectWithoutContact color="#0a1930" size={22} />,
    heading: "Conéctate",
    text: "¡Únete a nuestro equipo! Estamos buscando talento para una nueva oportunidad. Si quieres crecer profesionalmente en un entorno innovador, esta es tu oportunidad. Postúlate ahora y forma parte de nuestro éxito.",
  },
  {
    id: 4,
    icon: <FaGg color="#0a1930" size={22} />,
    heading: "infraestructura",
    text: "Expertos en Redes de comunicación y Fibra Óptica. Cableado estructurado y planta externa",
  },
   {
    id: 5,
    icon: <FaCloudscale color="#0a1930" size={22} />,
    heading: "Cloud",
    text: "SaaS, Aplicaciones listas para usar en la nube. PaaS, Plataformas para desarrollar y desplegar aplicaciones. IaaS, Infraestructura virtualizada en la nube.",
  },
 
];
